<template>
    <div>
        <tabs class="monitoring-reporting-tabs" ref="tab-sections" type="info" square>
            <tab-pane :id="report_type" :label="$t(key)" v-for="(report_type, key) in report_types" :key="key">
                <div class="monitoring-report-box row" v-for="(report, index) in reports[report_type]" :key="report_type + '_' + index">
                    <span
                        class="monitoring-remove-item tim-icons icon-trash-simple"
                        v-if="MonitoringForm.isEditable && ((!report.data.autoCreated && (loggedUser.role == UserRoles.ADMIN || loggedUser.role == UserRoles.REGIONAL_ADMIN) ))"
                        @click="removeReport(report.id, report_type, index)"
                        >
                    </span>
                    <div class="col-6">
                        <h3 class="mt-2 mb-0">{{ $t('monitoring.box_title__reporting_period', [index + 1, report.start_date, report.end_date]) }}</h3>
                    </div>
                    <div class="col-6">
                        <base-button
                            type="primary"
                            class="pull-right"
                            @click="viewReport(report.id,(index + 1))"
                            >
                            {{ $t('monitoring.button__report_progress') }}
                        </base-button>
                    </div>
                </div>
                <base-button
                    v-if="loggedUser.role == UserRoles.ADMIN || loggedUser.role == UserRoles.REGIONAL_ADMIN"
                    type="primary"
                    class="add-new-report"
                    @click="createReport(report_type)"
                    >
                    +
                    {{ $t('monitoring.button__add_new_report') }}
                </base-button>
            </tab-pane>
        </tabs>
    </div>
</template>
<script>
    import {MonitoringForm, MonitoringService} from '@/services';
    import {TabPane, Tabs} from 'src/components';
    import {UserRoles} from "@/services";

    export default
    {
        components:
        {
            MonitoringForm,
            Tabs,
            TabPane,
        },
        data()
        {
            return {
                MonitoringForm,
                report_types:
                {
                    'monitoring.tabs_label__monthly_report': 'monthly',
                    'monitoring.tabs_label__technical_report': 'technical',
                    'monitoring.tabs_label__financial_report': 'financial',
                },
                reports:
                {
                    monthly: [],
                    technical: [],
                    financial: [],
                },
                UserRoles
            }
        },
        computed:
        {
             loggedUser() {
                return this.$store.getters['Auth/loggedUser'];
            }
        },
        async beforeMount()
        {
            const loader = this.$loading.show();

            await MonitoringService.getApplicationReports({
                application_id: MonitoringForm.applicationId
            }).then((response) =>
            {
                this.reports = response.data;
            });

            loader.hide();
        },
        methods:
        {
            createReport(type)
            {
                const vm = this;

                MonitoringService.createReport({
                    type: type,
                    application_id: MonitoringForm.applicationId
                }).then((response) =>
                {
                    if (!vm.reports[type])
                    {
                        vm.reports[type] = [];
                    }

                    vm.reports[type].push(response.data);
                });
            },

            viewReport(report_id,key)
            {
                window.open('/monitoring/report/' + MonitoringForm.grantId + '/' + MonitoringForm.applicationId + '/' + report_id + '/' + key, '_blank');
            },

            removeReport(reportId, key, index)
            {
                if (confirm(this.$t('monitoring.confirm__remove_report')))
                {
                    MonitoringService.removeReport(reportId);
                    this.reports[key].splice(index, 1);
                }
            },

            getError(field)
            {
                return this.errors.first(field);
            },
            validate()
            {
                return this.$validator.validateAll().then(res =>
                {
                    this.$emit('on-validated', res, this.model);

                    return res;
                });
            },
        },
    };
</script>
<style lang="scss" scoped>

</style>
